// 规则校验

// 不能为空校验
export const requiredRule =  { required: true, message: '不能为空', trigger: 'blur' }

// 是手机号
export const isMobile = {
  trigger: 'blur',
  validator: (rule: any, value: any, callback: (error?: any) => void) => {
    if (!value) {
      callback()
      return
    }
    const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
    const isPhone = reg.test(value)
    //判断是否为数字
    value = value.toString() //转换成字符串
    if (value.length < 0 || value.length > 12 || !isPhone) {
      //判断是否为11位手机号
      callback(new Error('手机号码格式不正确如:138xxxx8754'))
    } else {
      callback()
    }
  },
}

// 是邮箱
export const isEmail = {
  trigger: 'blur',
  validator: (rule: any, value: any, callback: (error?: any) => void) => {
    if (!value) {
      callback()
      return
    }
    const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    const isEmail = reg.test(value)
    if (!isEmail) {
      callback(new Error('邮箱格式不正确'))
    } else {
      callback()
    }
  },
}
